import React from 'react'

export default function LabelAndData({ label, displayData }) {
  return (
    <div>
      <strong>{`${label}: `}</strong>
      {displayData}
    </div>
  )
}
